import { create } from "zustand";
import { persist } from "zustand/middleware";

interface MessageInfo {
  [key: string]: unknown;
}

interface MessagesState {
  currentMsgPageView: string;
  currentMsgInfo: MessageInfo | null;
  createMessageOpen: boolean;
  messageListVersion: number;
  setMsgCurrentPage: (view: string) => void;
  setCurrentMsgInfo: (message: MessageInfo | null) => void;
  setCreateMessageOpen: (open: boolean) => void;
  bumpMessageList: () => void;
}

export const useMessageStore = create<MessagesState>()(
  persist(
    (set) => ({
      currentMsgPageView: "MsgList",
      currentMsgInfo: null,
      createMessageOpen: false,
      messageListVersion: 0,
      setMsgCurrentPage: (view) => set({ currentMsgPageView: view }),
      setCurrentMsgInfo: (message) => set({ currentMsgInfo: message }),
      setCreateMessageOpen: (open) => set({ createMessageOpen: open }),
      bumpMessageList: () =>
        set((s) => ({ messageListVersion: s.messageListVersion + 1 })),
    }),
    {
      name: "portal-message",
      partialize: (state) => ({
        currentMsgPageView: state.currentMsgPageView,
        currentMsgInfo: state.currentMsgInfo,
      }),
    }
  )
);
